export default __webpack_public_path__ + "static/media/gray-sad.10c0ee36.svg";